import { ICreateTutorState } from '../interfaces/icreate-tutor-state';

export const CREATE_TUTOR_STATE: ICreateTutorState = {
  selectedStudent: null,
  selectedTutor: null,
  step: 0,
};

